import { render, staticRenderFns } from "./MenuOnline.vue?vue&type=template&id=16424c68&scoped=true"
import script from "./MenuOnline.vue?vue&type=script&lang=js"
export * from "./MenuOnline.vue?vue&type=script&lang=js"
import style0 from "./MenuOnline.vue?vue&type=style&index=0&id=16424c68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16424c68",
  null
  
)

export default component.exports